import type { SchemaBuilderExpressionVariablesWrapperProps } from "./schema-builder-expression-variables.type";

import { Form } from "antd";

import { SchemaBuilderExpressionVariables } from "./schema-builder-expression-variables.component";

export const SchemaBuilderExpressionVariablesWrapper = ({
  name,
}: SchemaBuilderExpressionVariablesWrapperProps) => {
  return (
    <Form.List name={[name, "variables"]}>
      {(fields) =>
        fields.length ? (
          <SchemaBuilderExpressionVariables name={name} fields={fields} />
        ) : null
      }
    </Form.List>
  );
};
